import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function ServerWindows() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const windowsVersions = [
        "Windows Server 2022",
        "Windows Server 2019",
        "Windows Server 2016",
        "Windows Server 2012 R2",
        "Hyper-V Server",
        "Windows 10/11 Enterprise"
    ];

    const microsoftServices = [
        "Active Directory Domain Services",
        "Exchange Server",
        "SQL Server",
        "SharePoint Server",
        "System Center (SCCM/SCOM)",
        "Windows Update Services (WSUS)",
        "Remote Desktop Services",
        "Internet Information Services (IIS)"
    ];

    const securityFeatures = [
        "Group Policy Management",
        "Windows Firewall Advanced",
        "BitLocker Drive Encryption",
        "Windows Defender ATP",
        "Certificate Services",
        "Backup e restore automatici",
        "Patch management",
        "Security compliance audit"
    ];

    const cloudIntegration = [
        "Azure Active Directory sync",
        "Microsoft 365 integration",
        "Azure Backup",
        "Azure Site Recovery",
        "Hybrid cloud setup",
        "Azure Arc management",
        "PowerShell DSC",
        "Azure Monitor"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Amministrazione Server Windows</h1>
                    <p className="service-description">
                        Gestione completa di server Windows Server, Active Directory, Exchange
                        e integrazione con servizi Microsoft Cloud per ambienti enterprise.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>Amministrazione Server Windows Professionale</h3>
                                <p>
                                    Gestisco infrastrutture Windows Server con competenza Microsoft-certified,
                                    dalla configurazione di Active Directory alla gestione di Exchange Server,
                                    garantendo sicurezza, prestazioni e integrazione cloud ottimali.
                                </p>
                                <p>
                                    Specializzato in ambienti enterprise Microsoft, offro soluzioni complete
                                    per la gestione di domini, posta elettronica, database SQL Server
                                    e integrazione con servizi Azure.
                                </p>
                            </div>

                            <div className="windows-versions">
                                <h3>Versioni Windows Server Supportate</h3>
                                <Row>
                                    {windowsVersions.map((version, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🖥️</span>
                                                {version}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="microsoft-services-section">
                                <h3>Servizi Microsoft Enterprise</h3>
                                <Row>
                                    {microsoftServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚙️</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="info" className="windows-alert">
                                <h5><i className="fab fa-microsoft"></i> Integrazione Microsoft 365</h5>
                                <p>
                                    Configurazione e gestione dell'integrazione tra i tuoi server on-premise
                                    e i servizi cloud Microsoft 365 per un ambiente ibrido ottimale.
                                </p>
                            </Alert>

                            <div className="security-section">
                                <h3>Sicurezza Windows Enterprise</h3>
                                <Row>
                                    {securityFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔒</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="cloud-integration-section">
                                <h3>Integrazione Cloud Azure</h3>
                                <Row>
                                    {cloudIntegration.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">☁️</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Metodologia di Gestione</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Assessment infrastruttura Windows esistente</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Configurazione Active Directory e Group Policy</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Setup monitoraggio e backup automatizzati</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Manutenzione proattiva e patch management</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani Windows</h4>
                                        <div className="pricing-plan">
                                            <h5>Windows Basic</h5>
                                            {/* <div className="plan-price">€180/mese</div> */}
                                            <ul>
                                                <li>1 Windows Server</li>
                                                <li>Active Directory base</li>
                                                <li>Backup settimanali</li>
                                                <li>Patch management</li>
                                                <li>Supporto 9-18</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan featured">
                                            <h5>Windows Professional</h5>
                                            {/* <div className="plan-price">€350/mese</div> */}
                                            <ul>
                                                <li>Fino a 3 Server</li>
                                                <li>Exchange Server</li>
                                                <li>SQL Server basic</li>
                                                <li>Azure integration</li>
                                                <li>Monitoraggio 24/7</li>
                                                <li>Supporto prioritario</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>Windows Enterprise</h5>
                                            {/* <div className="plan-price">€650/mese</div> */}
                                            <ul>
                                                <li>Server illimitati</li>
                                                <li>Domain Controller HA</li>
                                                <li>Exchange HA cluster</li>
                                                <li>SQL Server cluster</li>
                                                <li>Azure hybrid setup</li>
                                                <li>Supporto H24</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="windows-features-card">
                                    <Card.Body>
                                        <h4>🏢 Specializzazioni Enterprise</h4>
                                        <ul>
                                            <li>Domain Controller clustering</li>
                                            <li>Exchange Server HA</li>
                                            <li>SQL Server AlwaysOn</li>
                                            <li>SharePoint Farm</li>
                                            <li>RDS Server farm</li>
                                            <li>Hyper-V virtualization</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="microsoft-cert-card">
                                    <Card.Body className="text-center">
                                        <h5>🏆 Certificazioni Microsoft</h5>
                                        <p>Amministratore certificato Microsoft con competenze validate su:</p>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>Windows Server</li>
                                            <li>Azure Administrator</li>
                                            <li>Exchange Server</li>
                                            <li>SQL Server DBA</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Windows</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default ServerWindows;